export const SELECT_VERTICAL_TO_MARKETPLACE = 'SELECT_VERTICAL_TO_MARKETPLACE';
export const SELECT_STATIC_MODULES_TO_MARKETPLACE =
  'SELECT_STATIC_MODULES_TO_MARKETPLACE';
export const RESET_SELECT_VERTICAL_TO_MARKETPLACE =
  'RESET_SELECT_VERTICAL_TO_MARKETPLACE';
